import BaseModel from '../base.js';
class StoreModel extends BaseModel {
  async getList(params) {
    const {err, res} = await this.$ajax.get(this.$apiUrl.STORE.GET_LIST, {...params});
    return {err, res};
  }

  async getDetail(storeID) {
    const {err, res} = await this.$ajax.get(this.$apiUrl.STORE.GET_DETAIL, {storeID});
    return {err, res};
  }
}
export default StoreModel;

// ./src/model/modules/store/index.js



// WEBPACK FOOTER //
// ./src/model/modules/store/index.js